import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useTokenStore, useUserInfoStore, useWorkInfoStore } from '../../store';

import { useGetEntryRedirectPath } from './useGetEntryRedirectPath';

/**
 * @description - 앱 최초 실행 시 분기 조건에 따라 페이지를 이동시키는 커스텀훅
 */
export const useEntryCondition = ({ isAppTypeChecked = true }: { isAppTypeChecked?: boolean }) => {
  const navigate = useNavigate();

  const { resetTokens } = useTokenStore((state) => state.actions);
  const { resetUserInfo } = useUserInfoStore((state) => state.actions);
  const { resetWorkInfo } = useWorkInfoStore((state) => state.actions);

  const { redirectPath, isSuccess, getEntryRedirectPath } = useGetEntryRedirectPath();

  const resetStoredData = () => {
    resetUserInfo();
    resetTokens();
    resetWorkInfo();
  };

  useEffect(() => {
    if (redirectPath === null || isSuccess === null) {
      return;
    }

    if (!isSuccess) {
      resetStoredData();
      navigate('/login', { replace: true });
      return;
    }

    navigate(redirectPath, { replace: true });
  }, [isSuccess, redirectPath]);

  useEffect(() => {
    if (!isAppTypeChecked) {
      return;
    }

    (async () => {
      await getEntryRedirectPath();
    })();
  }, [isAppTypeChecked]);
};
